import React from 'react';
import { FadeIn } from './FadeIn';
import { Shield } from 'lucide-react';
interface ArsenalItem {
  cover?: string;
  title: string;
  subtitle: string;
  desc: string;
  value: string;
}
export function ArsenalSection() {
  const items: ArsenalItem[] = [{
    cover: 'https://cdn.magicpatterns.com/uploads/daztqiWmen7ceve4wfF7Ps/COVER.png',
    title: 'L\u2019Algorithme de l\u2019Amour',
    subtitle: 'Ebook Principal',
    desc: 'Le guide intégral pour dominer la psychologie du dating digital.',
    value: 'Valeur 47$'
  }, {
    title: "Le Protocole 'Identity Shift'",
    subtitle: "Plan d'action 21 jours",
    desc: "Votre plan d'action quotidien pour passer du mode 'option' au mode 'priorité'.",
    value: 'Inclus dans le ebook'
  }, {
    cover: 'https://cdn.magicpatterns.com/uploads/gAdVafEEb7rYzEbUhvTirs/COVER_BONUS_1.png',
    title: 'Le Lexique Secret',
    subtitle: 'Bonus #1',
    desc: "50 phrases exactes à copier-coller pour recadrer les paresseux et décrocher le 'Date'.",
    value: 'Valeur 27$'
  }, {
    cover: 'https://cdn.magicpatterns.com/uploads/nUKpe8GUUrRK5DwPfik4Wk/COVER_BONUS_2.png',
    title: 'Le Détecteur de Cons',
    subtitle: 'Bonus #2',
    desc: "Comment identifier un narcissique ou un 'Time-Waster' en seulement 3 messages.",
    value: 'Valeur 27$'
  }];
  return <section className="py-16 md:py-32 bg-deep-black relative" data-id="element-12">
      <div className="absolute top-1/2 right-0 w-96 h-96 bg-champagne-gold/5 rounded-full blur-[150px]" data-id="element-13"></div>

      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-14">
        <FadeIn data-id="element-15">
          <div className="text-center mb-20" data-id="element-16">
            <span className="text-champagne-gold text-xs font-semibold tracking-[0.2em] uppercase mb-4 block" data-id="element-17">
              Votre Arsenal
            </span>
            <h2 className="font-playfair text-4xl md:text-5xl text-cream" data-id="element-18">
              Ce Que Vous Recevez{' '}
              <span className="italic text-champagne-gold" data-id="element-19">Immédiatement</span>
            </h2>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-5 md:gap-8" data-id="element-20">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-21">
              <div className="group relative bg-glass-burgundy backdrop-blur-sm border border-burgundy/40 hover:border-champagne-gold/50 rounded-3xl p-5 md:p-8 transition-all duration-500 hover:-translate-y-2 hover:shadow-burgundy-glow overflow-hidden h-full" data-id="element-22">
                <div className="absolute top-0 right-0 w-32 h-32 bg-champagne-gold/5 rounded-bl-full transition-transform duration-500 group-hover:scale-150" data-id="element-23"></div>

                <div className="relative z-10 flex flex-col items-center text-center gap-6" data-id="element-24">
                  {item.cover ? <div className="relative flex-shrink-0" data-id="element-25">
                      <div className="absolute -inset-3 bg-champagne-gold/8 rounded-2xl blur-xl" data-id="element-26"></div>
                      <img src={item.cover} alt={item.title} className="relative w-40 md:w-48 rounded-xl shadow-lg shadow-champagne-gold/10 border border-champagne-gold/15 transition-transform duration-500 group-hover:scale-105" data-id="element-27" />
                    </div> : <div className="p-5 bg-deep-black/50 rounded-2xl border border-champagne-gold/20" data-id="element-28">
                      <Shield className="w-10 h-10 text-champagne-gold" data-id="element-29" />
                    </div>}
                  <div data-id="element-30">
                    <div className="text-xs text-champagne-gold tracking-widest uppercase mb-2 font-semibold" data-id="element-31">
                      {item.subtitle}
                    </div>
                    <h3 className="font-playfair text-2xl text-cream mb-3" data-id="element-32">
                      {item.title}
                    </h3>
                    <p className="text-muted-cream font-light text-sm leading-relaxed mb-4" data-id="element-33">
                      {item.desc}
                    </p>
                    <div className="inline-block px-3 py-1 bg-burgundy/30 border border-burgundy rounded-full text-xs text-cream font-medium" data-id="element-34">
                      {item.value}
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}